import { useState } from 'react';
import { submit } from '../../app/thunks/form-submit.thunk';
import { FormContainer } from '../../fxfs/schema/form.schema';
import { useAppDispatch } from '../../app/hooks';
import { FormData } from '../../services/interfaces/session.interface';

export const useForm = (schema: FormContainer) => {
	const [data, setData] = useState<FormData>([]);
	const [submitting, setSubmitting] = useState<boolean>(false);
	const [isFormValid, setIsFormValid] = useState<boolean>(false);

	const dispatch = useAppDispatch();

	const onChange = (data: FormData) => {
		setData(data);
	};

	const onValidationChange = (valid: boolean) => {
		setIsFormValid(valid);
	};

	const onSubmit = async () => {
		setSubmitting(true);
		const formId = schema.form_identifier;
		try {
			await dispatch(submit(formId, data));
		} finally {
			setSubmitting(false);
		}
	};

	const isSubmitDisabled = !isFormValid || submitting;
	return {
		data,
		submitting,
		isFormValid,
		isSubmitDisabled,
		onChange,
		onValidationChange,
		onSubmit
	};
};
